<template>
  <div :class="inline ? ['lg:flex', 'md:items-center'] : ''">
    <div :class="inline ? ['lg:w-1/3'] : ''">
      <label v-if="label" :class="['form-label', inline ? ['lg:text-right', 'lg:pr-4'] : '']" :for="id">{{ label }}:</label>
    </div>
    <div :class="inline ? ['lg:w-2/3'] : ''">
      <!-- <input :id="id" ref="input" v-bind="$attrs" class="form-input" :class="{ error: error }" :type="type" :value="value" @input="$emit('input', $event.target.value)" /> -->
      <flat-pickr :id="id" ref="input" v-bind="$attrs" class="form-input" :class="{ error: error }" :value="value" @input="$emit('input', $event)" :config="config"></flat-pickr>
      <div v-if="error" class="form-error">{{ error }}</div>
    </div>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css';

export default {
  inheritAttrs: false,
  components: {
    flatPickr,
  },
  props: {
    id: {
      type: String,
      default() {
        return `date-input-${this._uid}`
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    value: String|Number,
    label: String,
    error: String,
    inline: {
      type: Boolean,
      default() {
        return false;
      }
    },
  },
  data() {
    return {
      config: {
        altFormat: 'j M Y',
        altInput: true,
        allowInput: true,
      }
    }
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end)
    },
  },
}
</script>
